import { CustomerBillingOtherCustomerModel } from './customer-billing-other-customer.model';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import { CurrencyTypes } from '../customer-billing-price/currency-type';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { fiPaymentMethodTypeName } from '../payment-method-type';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { OtherInvoicesListItemComponent } from '../customer-billing-customer/other-invoices-list-item/other-invoices-list-item.component';
import { Injector } from '@angular/core';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { createMap } from '@fi-shared/utils/create-map';

export class CustomerBillingOtherCustomerListData extends ListData<CustomerBillingOtherCustomerModel> {
    private CurrencyTypesMap = createMap(CurrencyTypes, 'Id');

    constructor(injector: Injector) {
        super(injector);
        this.ShowDelete = false;
        this.ObjectType = ObjectTypes.OtherBillingCustomer;

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.customer'),
                'Name',
                new ItemsListHeaderProperties('CcmListItem-Name', true, ItemsListElementType.A, {
                    Sref: FiStateNames.CustomerBilling.OtherCustomers.View,
                    SrefParams: (data) => ({ Id: data.CustomerId }),
                }),
            ),
        );

        this.addSpanPlainHeader(
            this.appTextService.get('billing.payment_method'),
            'PaymentMethodType',
            '',
            true,
            (data, property) => {
                return fiPaymentMethodTypeName(data[property], this.appTextService);
            },
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('customer_billing.invoices'),
                'OtherInvoices',
                new ItemsListHeaderProperties('', false, OtherInvoicesListItemComponent),
            ),
        );

        this.addSpanPlainHeader(
            this.appTextService.get('common.discount') + ' %',
            'Discount',
            '',
            true,
            this.formatPercents,
        );

        this.addSpanPlainHeader(
            this.appTextService.get('billing.extra_discount') + ' %',
            'ExtraDiscount',
            '',
            true,
            this.formatPercents,
        );

        this.addSpanPlainHeader(
            this.appTextService.get('billing.currency'),
            'Currency',
            '',
            false,
            (data, property) => {
                if (this.CurrencyTypesMap.hasOwnProperty(data[property]))
                    return this.appTextService.get(this.CurrencyTypesMap[data[property]].TextId);

                return '-';
            },
        );
    }

    private formatPercents = function (data, property) {
        return data[property] > 0 ? data[property] + '%' : '-';
    };
}
